/*
 * Author M. Atoar Rahman
 * Title: D3 Report
 * Description: Index for D3 Report
 * Date: 05/06/2022
 */

import { Card } from 'react-bootstrap';
import { useConsumptionTally } from './ContextAPI';
import FormInfo from './FormInfo';
import PrintIndex from './pdf/PrintIndex';

export default function Index() {
    const { showPdf } = useConsumptionTally();

    return showPdf ? (
        <PrintIndex />
    ) : (
        <Card>
            <Card.Header className="cardHeader">
                <h3>Consumption Tally</h3>
            </Card.Header>
            <Card.Body>
                <FormInfo />
            </Card.Body>
        </Card>
    );
}
